module.exports = __webpack_public_path__ + "static/assets/7201464600b2037f01da2a7558602902.svg";